module.exports = {
  ServicePath: "http://115.124.123.147:5010",
  authorizedURL: "http://gcadmin.unitedwaybaroda.org/",
  // ServicePath: "http://localhost:5010",
  // authorizedURL: "http://localhost:3000",
};
